<fieldset>
    <div nz-row [nzGutter]="[0, 10]">
        <div nz-col nzSpan="24">
            <div id="stripe-card-element" class="input"></div>
        </div>
    </div>
    <div nz-row *ngIf="!hideAddButton">
        <nz-col nzSpan="6"></nz-col>
        <nz-col nzSpan="12">
            <button
                nz-button
                style="width: 100%"
                nzSize="large"
                nzType="primary"
                nzShape="round"
                (click)="addPayment()"
            >
                Add
            </button>
        </nz-col>
        <nz-col nzSpan="6"></nz-col>
    </div>
</fieldset>
<div class="caption">
    <span class="body3">Payment secured by Stripe</span>
    <span class="body3" *ngIf="testEnv"
        ><br />FOR TESTING USE: 4000001240000000</span
    >
</div>
